import { create } from 'zustand'

/**
 * Global store for per-page popup modals.
 * 
 * Each page (settings, dashboard, plus, partner, support, management, admin) opens its own popup.
 * The page's top tabs become the left sidebar of its popup.
 *
 * activeModal: 'settings' | 'dashboard' | 'plus' | 'partner' | 'support' | 'management' | 'admin' | null
 * activeTab: sub-tab within the modal (e.g. 'profile', 'wallet', 'creator:general')
 * extra: optional data (e.g. { promotePostId })
 */

const DEFAULTS = {
  settings: 'profile',
  dashboard: 'overview',
  plus: null,
  partner: null,
  support: 'reports',
  management: 'content',
  admin: 'revenue',
}

export const useCommandModal = create((set) => ({
  activeModal: null,
  activeTab: null,
  extra: null,

  /**
   * Open a specific modal with an optional tab and extra data.
   * @param {string} modal - 'settings' | 'dashboard' | 'plus' | 'partner' | 'support' | 'management' | 'admin'
   * @param {object} [opts] - { tab, extra }
   */
  open: (modal, opts = {}) => set({
    activeModal: modal,
    activeTab: opts.tab || DEFAULTS[modal] || null,
    extra: opts.extra || null,
  }),

  /** Switch tab within the currently open modal */
  setTab: (tab) => set({ activeTab: tab }),

  close: () => set({ activeModal: null, activeTab: null, extra: null }),
}))
